import { useTheme } from 'styled-components';

import {
   StyledLetter,
   StyledLetterSeparator,
   StyledLetterSeparatorLine,
} from './DocumentTemplateLetterSeparator.styled';

type DocumentTemplateLetterSeparatorProps = {
   readonly letter: string;
   readonly asSpacer?: boolean;
};

export const DocumentTemplateLetterSeparator = (props: DocumentTemplateLetterSeparatorProps): JSX.Element => {
   const theme = useTheme();

   return (
      <StyledLetterSeparator $spacer={Boolean(props.asSpacer)}>
         <StyledLetter testId={'letterSeparator'} textTransform={'uppercase'} color={theme.backgroundDark}>
            {props.letter}
         </StyledLetter>
         <StyledLetterSeparatorLine />
      </StyledLetterSeparator>
   );
};
